document.querySelectorAll('.gh-newsletter-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const input = form.querySelector('input[type="email"]');
        const message = form.querySelector('.gh-form-message');
        const label = form.dataset.label;

        const email = input.value;

        message.textContent = 'Sending...';

        try {
            const res = await fetch('/members/api/send-magic-link/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email,
                    labels: label ? [label] : []
                })
            });

            if (res.ok) {
                message.textContent = 'Check your email to confirm subscription!';
                input.value = '';
            } else {
                message.textContent = 'Something went wrong. Try again.';
            }
        } catch (err) {
            message.textContent = 'Error. Try again later.';
        }
    });
});